import React from "react";

const AVATAR = { teal: "var(--nx-avatar-bg)" };

function initialOf(name) {
  return (name || "?").trim().charAt(0).toUpperCase() || "?";
}

// Circular artist avatar: the profile photo (photoURL, from the /api/artists
// overlay) when there is one, over the initial-letter fallback. The letter
// stays underneath until the image has loaded - same layering as ArtistPage -
// so the circle is never empty, and a broken URL just leaves the letter
// showing. Used by the homepage's lists (Home.jsx).
export default function ArtistAvatar({ name, photoURL, size }) {
  const [loaded, setLoaded] = React.useState(false);
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => { setLoaded(false); setFailed(false); }, [photoURL]);
  return (
    <span style={s.avatar(size)}>
      {initialOf(name)}
      {photoURL && !failed && (
        <img src={photoURL} alt="" style={s.avatarImg(loaded)}
          referrerPolicy="no-referrer" decoding="async" draggable={false}
          onLoad={() => setLoaded(true)} onError={() => setFailed(true)} />
      )}
    </span>
  );
}

const s = {
  avatar: (px) => ({ position: "relative", overflow: "hidden", width: `${px}px`, height: `${px}px`, flexShrink: 0, borderRadius: "999px", background: AVATAR.teal, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "var(--nx-font-display)", fontWeight: 700, fontSize: px >= 40 ? "16px" : px >= 32 ? "14px" : "12px", color: "#fff" }),
  avatarImg: (loaded) => ({ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit", opacity: loaded ? 1 : 0, transition: "opacity 0.15s ease" }),
};
